<template>
	<div class="icon-settings-profile">
		<svg
			width="24.000000"
			height="24.000000"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_2202">
					<rect
						id="search"
						width="24.000000"
						height="24.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_2202)">
				<path
					id="path"
					d="M12 15.75C9.92 15.75 8.25 14.07 8.25 12C8.25 9.92 9.92 8.25 12 8.25C14.07 8.25 15.75 9.92 15.75 12C15.75 14.07 14.07 15.75 12 15.75L12 15.75M12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75L12 9.75Z"
					:fill="isHover ? 'var(--theme-color)' : color"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
				<path
					id="path"
					d="M15.21 22.18C15 22.18 14.79 22.15 14.58 22.1C13.96 21.93 13.43 21.54 13.11 20.99L12.99 20.79C12.39 19.77 11.59 19.77 11 20.79L10.88 20.98C10.56 21.54 10.04 21.94 9.41 22.1C8.79 22.27 8.13 22.18 7.59 21.85L5.87 20.86C5.26 20.51 4.82 19.94 4.62 19.25C4.44 18.56 4.54 17.85 4.88 17.24C5.17 16.73 5.26 16.27 5.09 15.98C4.91 15.69 4.48 15.52 3.89 15.52C2.43 15.52 1.25 14.33 1.25 12.87L1.25 11.11C1.25 9.65 2.43 8.46 3.89 8.46C4.48 8.46 4.91 8.29 5.09 8C5.26 7.71 5.18 7.25 4.88 6.74C4.54 6.13 4.44 5.41 4.62 4.73C4.81 4.04 5.25 3.47 5.87 3.12L7.6 2.13C8.72 1.46 10.22 1.85 10.89 3L11.02 3.2C11.61 4.22 12.41 4.22 13.01 3.2L13.12 3.01C13.8 1.85 15.29 1.46 16.42 2.14L18.14 3.13C18.76 3.48 19.2 4.05 19.38 4.74C19.57 5.43 19.48 6.14 19.12 6.75C18.84 7.26 18.76 7.72 18.92 8.01C19.1 8.3 19.53 8.47 20.12 8.47C21.58 8.47 22.77 9.66 22.77 11.12L22.77 12.88C22.77 14.34 21.58 15.53 20.12 15.53C19.53 15.53 19.1 15.7 18.92 15.99C18.76 16.28 18.83 16.74 19.12 17.25C19.48 17.86 19.58 18.58 19.38 19.26C19.2 19.95 18.77 20.52 18.14 20.87L16.41 21.86C16.04 22.07 15.62 22.18 15.21 22.18L15.21 22.18M12 18.48C12.88 18.48 13.72 19.04 14.29 20.03L14.39 20.22C14.52 20.43 14.72 20.58 14.96 20.64C15.2 20.7 15.43 20.67 15.63 20.55L17.37 19.55C17.62 19.4 17.83 19.15 17.9 18.85C17.99 18.55 17.95 18.24 17.79 17.98C17.23 17 17.15 15.99 17.6 15.22C18.04 14.45 18.95 14.01 20.09 14.01C20.73 14.01 21.24 13.5 21.24 12.86L21.24 11.1C21.24 10.47 20.73 9.95 20.09 9.95C18.95 9.95 18.04 9.51 17.6 8.74C17.15 7.97 17.23 6.96 17.79 5.98C17.95 5.72 17.99 5.41 17.9 5.11C17.83 4.81 17.63 4.57 17.37 4.41L15.64 3.42C15.22 3.16 14.64 3.31 14.38 3.75L14.28 3.94C13.71 4.93 12.87 5.49 11.99 5.49C11.1 5.49 10.27 4.93 9.69 3.94L9.59 3.74C9.34 3.32 8.78 3.17 8.35 3.42L6.62 4.42C6.36 4.57 6.15 4.82 6.08 5.12C6 5.42 6.04 5.73 6.18 5.99C6.76 6.97 6.83 7.98 6.38 8.75C5.94 9.52 5.04 9.96 3.89 9.96C3.26 9.96 2.75 10.47 2.75 11.11L2.75 12.87C2.75 13.5 3.26 14.02 3.89 14.02C5.04 14.02 5.94 14.46 6.38 15.23C6.83 16 6.76 17.01 6.18 17.99C6.04 18.25 6 18.56 6.08 18.86C6.15 19.16 6.35 19.4 6.61 19.56L8.34 20.55C8.55 20.68 8.8 20.71 9.03 20.65C9.27 20.59 9.46 20.43 9.6 20.22L9.7 20.03C10.28 19.05 11.11 18.48 12 18.48L12 18.48Z"
					:fill="isHover ? 'var(--theme-color)' : color"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
	props: {
		isHover: { type: Boolean, default: false },
		color: { type: String, default: "rgb(188, 192, 207)" },
	},
})
export default class IconSettingsProfile extends Vue {}
</script>

<style scoped lang="scss">
.icon-settings-profile {
	display: flex;
}
</style>
